/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Contact, ContactType as ContactTypeToken, ContactTypeToReset } from '.'

export enum ActivateStep {
    newPassword = 0,
    selectContact = 1,
    validateToken = 2,
}

export interface AccountState {
    id?: number
    name?: string
    socialName?: string
    cpf?: string
    birthDate?: string
    term?: boolean
    biologicalSex?: string
    password?: string
    postalCode?: string
    contact?: Contact
    email?: string
    phone?: string
    phoneContacts?: Array<Contact>
    emailContacts?: Array<Contact>
    isRecoverPassword?: boolean
    destinationToken?: string
    tokenCIP?: string
    patientLoginMdmAccount?: string
}

export enum ContactType {
    MOBILE = 'MOBILE',
    EMAIL = 'EMAIL',
}

export interface ConfirmTokenType {
    userName?: string
    token?: string
    password?: string
}

export interface ConfirmTokenData {
    confirmToken: {
        message: string
        authentication: {
            access_token: string
            refresh_token: string
        }
    }
}

export interface PatientInfoInput {
    name?: string
    birthDate?: string
    biologicalSex?: string
    cellphone?: string
    cpf?: string
    email?: string
    password?: string
    zipCode?: string
    term?: boolean
}

export interface PatientInfoSearch {
    viewerSearch: {
        id: number
        phone: string
        biologicalSex: string
        cep: string
        phoneContacts: Array<Contact>
        emailContacts: Array<Contact>
    }
}

export interface ValidateLoginContactResponse {
    validateLoginContact: {
        status: ContactLoginStatus
    }
}

export enum ContactLoginStatus {
    CONTACTLINKED = 'CONTACTLINKED',
    CONTACTNOTLINKED = 'CONTACTNOTLINKED',
}

export interface PatientLogin {
    password?: string
    contactId?: number
    cpf?: string
    biologicalSex?: string
    cep?: string
    destination?: ContactTypeToken
}

export interface CheckAccountType {
    checkAccount: CheckAccountResponse
}

export interface CheckAccountResponse {
    accountSearch: AccountSearch
    accountLoginSearch: AccountLoginSearch
    status?: CheckAccountStatus
    federalTaxId: string
    hasMultipleRegistrations: boolean
    hasCipPassword: boolean
}

export interface ContactsToResetResponse
    extends Array<{
        id: number
        type: ContactTypeToReset
        contact: string
    }> {}

export interface ContactsToResetType {
    contactsToReset: ContactsToResetResponse
}

export interface CreateLoginType {
    createLogin: {
        message: string
        cipIntegrationStatus: CipIntegrationStatus
        examsIntegrationStatus: ExamsIntegrationStatus
    }
}

export interface CreateLoginResponse {
    createLoginResponse: {
        message: string
        cipIntegrationStatus: CipIntegrationStatus
        examsIntegrationStatus: ExamsIntegrationStatus
    }
}

export enum CipIntegrationStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    UNSOLICITED = 'UNSOLICITED',
}

enum ExamsIntegrationStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
}

export interface Contacts {
    cpf: string
    phoneContacts: Contact[]
    emailContacts: Contact[]
}

export enum TokenProcessSSO {
    CREATE_LOGIN = 'CREATE_LOGIN',
    CHANGE_PASS = 'CHANGE_PASS',
}

export interface ResendTokenType {
    cpf?: string
    password?: string
    cellphone?: string
    email?: string
    biologicalSex?: string
    cep?: string
    contactId?: number
    destination?: ContactTypeToken
    dispatchType?: string
    process?: TokenProcessSSO
}

export interface PatientMDMInfoSearch {
    viewerSearch: {
        id: number
        phone: string
        biologicalSex: string
        cep: string
        phoneContacts: Contact[]
        emailContacts: Contact[]
    }
}
export interface FormDataVerification {
    id: number
    postalCode: string
    biologicalSex: string
    phoneContacts?: Contact[]
    emailContacts?: Contact[]
}

export interface CreatePatientInput {
    name?: string
    socialName?: string
    birthDate?: string
    biologicalSex?: string
    sexualOption?: SexualOptions
    cellphone?: string
    cpf?: string
    email?: string
    password?: string
    zipCode?: string
    emailToken?: boolean
    operatorId?: string
    registrationNumber?: string
}

export interface CreatePatientType {
    createPatientAccount: {
        cipIntegrationStatus?: CipIntegrationStatus
        patient: {
            id: number
        }
    }
}

interface AccountSearch {
    id: number
    phone: string
    biologicalSex: string
    cep: string
    email: string
    phoneContacts: Contact[]
    emailContacts: Contact[]
}

interface AccountLoginSearch {
    mobile: string
    email: string
}

export interface TokenCIPInput {
    tokenCIP: string
}

export interface AssociateCipType {
    associateCip: {
        status: CIPStatus
    }
}

export enum CIPStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    UNSOLICITED = 'UNSOLICITED',
}

export enum CheckAccountStatus {
    LOGINFOUND = 'LOGINFOUND',
    LOGINFOUNDED = 'LOGINFOUNDED',
    LOGINNOTFOUND = 'LOGINNOTFOUND',
    ACCOUNTNOTFOUND = 'ACCOUNTNOTFOUND',
    BACKOFFICE = 'BACKOFFICE',
    INSUFFICIENTDATA = 'INSUFFICIENTDATA',
    UNDERAGE = 'UNDERAGE',
    NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
    CIPWITHOUTACCOUNT = 'CIPWITHOUTACCOUNT',
    DATADONTMATCH = 'DATADONTMATCH',
}

// enum GenderOptions {
//     FEMININO = 'FEMININO',
//     MASCULINO = 'MASCULINO',
//     INTERSEXUAL = 'INTERSEXUAL',
// }

enum SexualOptions {
    HETEROSSEXUAL = 'HETEROSSEXUAL',
    BISSEXUAL = 'BISSEXUAL',
    TRANSGENERO = 'TRANSGENERO',
    HOMOSSEXUAL = 'HOMOSSEXUAL',
}

export enum DestinationToken {
    MOBILE = 'MOBILE',
    WHATSAPP = 'WHATSAPP',
    SMS = 'SMS',
    EMAIL = 'EMAIL',
}

export type LoginMdmAccount = {
    password: string | undefined
    cpf: string | undefined
    contactId: number | undefined
    biologicalSex: string | undefined
    cep: string | undefined
    destinationToken: ContactTypeToken
}
